<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Menus</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-00</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de menús
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del menú"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerMenu"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" v-if="$localStorageService.can('BO_01_alta_menu')">
              <b-button v-b-tooltip.hover title="Crear menú" variant="outline-success"
                        @click="agregar()">Crear menú
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
              <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFechaCorta }}
                            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Detalle del plan"
                    size="sm"
                    @click="detalle(row.item)"
                    variant="outline-danger"
                ><em class="fa fa-eye"></em></b-button>
                <b-button
                    v-if="$localStorageService.can('BO_01_modif_menu')"
                    title="Modificar plan"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('BO_01_activar_menu')"
                          title="Activar menú"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('BO_01_baja_menu')"
                          title="Eliminar menu"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
      <b-container fluid>
        <div class="grid-container">
          <div v-for="fileName in fileNames" :key="fileName" class="grid-item">
            <img alt="img" :src="fileName" style="width: 50px; height: 50px; object-fit: contain;" />
          </div>
        </div>

          
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="nombreMenu">Nombre
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nombreMenu" name="nombreMenu" placeholder="Nombre del menú"
                                v-model="$v.menu.nombreMenu.$model"
                                :state="validateState('nombreMenu')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="padre">Menú asociado</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="padre" name="padre"
                            placeholder="Menú al cual está asociado"
                            v-model="menu.padre"
                            :reduce="item => item.idMenu"
                            label="nombreMenu"
                            :options="menuslista"
                            style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="permiso">Permiso
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="card-checklist"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="permiso" name="permiso" placeholder="Permiso"
                            label="permiso"
                            :options="permisos"
                            v-model="$v.menu.permiso.$model"
                            :state="validateState('permiso')"
                            style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="orden">Orden
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="list-nested"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="orden" name="orden" placeholder="Numero de orden de aparición"
                                type="number"
                                v-model="$v.menu.orden.$model"
                                :state="validateState('orden')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="url">NAME</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="globe"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="url" name="url" placeholder="Url de direccion"
                                type="text"
                                v-model="menu.url"
                                style="text-transform: none !important;"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showDetalle"
        :title="'Detalle del menú'"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <div v-if="menuDetalle !== null">
              <b-form-group align="left">
                <label for="nombreMenu">Nombre
                  <validacion/>
                </label>
                <p>{{ menuDetalle.nombreMenu }}</p>
              </b-form-group>
              <b-form-group align="left" v-if="menuDetalle.padre !== null">
                <label for="padre">Menú asociado</label>
                <p>{{ menuDetalle.padre }}</p>
              </b-form-group>
              <b-form-group align="left">
                <label for="permiso">Permiso
                  <validacion/>
                </label>
                <p>{{ menuDetalle.permiso.permiso }}</p>
              </b-form-group>
              <b-form-group align="left">
                <label for="orden">Orden
                  <validacion/>
                </label>
                <p>{{ menuDetalle.orden }}</p>
              </b-form-group>
              <b-form-group align="left" v-if="menuDetalle.url !== null">
                <label for="url">NAME</label>
                <p style="text-transform: none !important;">{{ menuDetalle.url }}</p>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModal()">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required, numeric} from "vuelidate/lib/validators";


export default {
  name: "munuIndex",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idMenu", label: "ID", sortable: true},
        {key: "nombreMenu", label: "Nombre", sortable: true},
        {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
        {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      show: false,
      showDetalle: false,
      tituloModal: '',
      menu: {
        idMenu: null,
        nombreMenu: null,
        permiso: null,
        orden: null,
        registroActivo: null,
        url: null,
        padre: null
      },
      menuDetalle: null,
      permisos: [],
      loaderAcciones: false,
      loader: false,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      menuslista: [],
      fileNames: [],
      mySVG: require('@/assets/menuIcons/diente.svg')
    }
  },
  validations: {
    menu: {
      nombreMenu: {required},
      permiso: {required},
      orden: {required, numeric},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerNombresIconos();
    this.obtenerMenu();
    this.obtenerMenuLista();
    this.obtenerPermisos();
  },
  methods: {
    obtenerNombresIconos(){
      const requireContext = require.context('@/assets/menuIcons', false, /\.(png|jpe?g|gif|svg)$/);

// Obtener una lista de los nombres de todos los archivos en la carpeta assets
this.fileNames = requireContext.keys().map((name) => {
  // Remover el prefijo "./" del nombre del archivo
  const fileName = name.replace('./', '');
  const file = require(`@/assets/menuIcons/${fileName}`);
  return file;
  
});
    },


    
    obtenerMenu() {
      this.loader = true
      this.datosTabla = [];
      this.$http.post(this.$api + 'menu/listaMenus', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    obtenerMenuLista() {
      this.menuslista = [];
      this.$http.post(this.$api + 'menu/listaMenus', {}).then(respuesta => {
            if (respuesta.data.data) {
              this.menuslista = respuesta.data.data
            }
          }
      ).finally(() => {
          }
      )
    },
    obtenerPermisos() {
      this.$http.get(this.$api + "catalogos/listaPermisos").then(response => {
            if (response.data.data) {
              this.permisos = response.data.data
            }

          }
      )
    },
    detalle(item) {
      this.menuDetalle = item;

      if (item.padre !== null) {
        this.datosTabla.forEach(it => {
          if (it.idMenu == item.padre) {
            this.menuDetalle.padre = it.nombreMenu
          }
        })
      }

      this.showDetalle = true;
    },
    agregar() {
      this.menu = {
        idMenu: null,
        nombreMenu: null,
        permiso: null,
        orden: null,
        url: null,
        padre: null
      };
      this.tituloModal = 'Agregar menú';
      this.show = true;
    },
    guardar() {
      this.$v.menu.$touch();
      if (this.$v.menu.$anyError) {
        return;
      }
      if (!this.$v.menu.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'menu/guardar', this.menu).then(respuesta => {
              if (respuesta.data.data) {
                this.obtenerMenu();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El menú se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.menu = item;
      this.tituloModal = 'Modificar menú';
      this.show = true;
    },

    eliminar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el menú?' : '¿Está seguro de activar el menú?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idMenu: item.idMenu,
          }
          this.$http.post(this.$api + 'menu/eliminar', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El menú se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.menu[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
    }
  }
}

</script>

<style scoped>
  .grid-container {
    width: 50%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 5px; /* Espacio reducido a la mitad */
}

  .grid-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>
